import { EVENT_NAME as ADD_TO_WEB_PROJECT_EVENT } from '@adobe-fonts/site/events/AddToWebProjectEvent.js';
import { addFamilyToWebProjectWithAuthentication } from '../../util/add_to_web_project_util.js';

export function registerEventHandlers(element) {
  element.addEventListener(ADD_TO_WEB_PROJECT_EVENT, handleAddToWebProjectEvent);
}

function handleAddToWebProjectEvent(event) {
  const card = event.target.closest('[data-slug]');
  if (!card || !('slug' in card.dataset)) {
    return;
  }

  addFamilyToWebProjectWithAuthentication(card.dataset.slug);
}
